import { render, staticRenderFns } from "./QuoteAttachmentCategoryModal.vue?vue&type=template&id=2f8142bf"
import script from "./QuoteAttachmentCategoryModal.vue?vue&type=script&lang=js"
export * from "./QuoteAttachmentCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports